<template>
  <div class="components-organization-tree" :class="{hideSearch: !showSearch}">
    <div class="search-wrapper" v-if="showSearch">
      <el-select
        class="search-select"
        v-model="searchFormData.tagCodes"
        :multiple="multiple"
        size="mini"
        placeholder="全部组织"
        @change="search"
      >
        <el-option
          v-for="item in organizationTypeList"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        ></el-option>
      </el-select>
    </div>
    <div class="tree-wrapper">
      <el-tree
        ref="tree"
        :highlight-current="true"
        :data="treeData"
        :props="propsOption"
        :load="loadNode"
        :node-key="nodeKey"
        :expand-on-click-node="false"
        :default-expanded-keys="defaultExpandedKeys"
        :default-checked-keys="defaultCheckedKeys"
        :current-node-key="currentNodeKey"
        lazy
        :show-checkbox="showCheckbox"
        @check="checkItem"
        @node-click="handleNodeClick"
      >
        <div
          class="custom-tree-node"
          slot-scope="{ node }"
          :title="node.label"
          :class="{isSelected: node.data.isSelected}"
        >{{node.label}}</div>
      </el-tree>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "organization-tree",
  props: {
    defaultTagCodes: {
      type: [Array, String],
      default: () => []
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    propsOption: {
      type: Object,
      default: () => {
        return {
          label: "name",
          children: "children",
          isLeaf: "isLeaf",
          nodeKey: "id"
        };
      }
    },
    defaultCheckedKeys: {
      type: Array,
      default: () => []
    },
    nodeKey: {
      type: String,
      default: "id"
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    dataPermissions: {
      type: Boolean,
      default: false
    },
    old: {
      type: Boolean,
      default: false
    },
    positionId: {
      default: ""
    },
    // 顶部选择框是否为多选
    multiple: {
      default: false
    },
    isRole: {
      default: false
    },
    currentNodeKey: {
      default: "1088640745113845762"
    },
    enable: {
      default: false
    }
  },
  data() {
    return {
      searchFormData: {
        tagCodes: [],
        parentId: "0",
        id: 0
      },
      treeData: [],
      defaultExpandedKeys: []
    };
  },
  computed: {
    ...mapState({
      organizationTypeList(state) {
        if (this.dataPermissions) {
          return state.dataDictionary.organizationTypeList.filter(
            item => item.name === "资金" || item.name === "明源"
          );
        } else {
          return state.dataDictionary.organizationTypeList;
        }
      }
    })
  },
  created() {
    this.$store.dispatch("getDictionaryOrganizationTypeList");
    this.searchFormData.tagCodes = this.defaultTagCodes;
  },
  mounted() {},
  watch: {
    defaultTagCodes: {
      handler(val) {
        if (typeof val === "string" && val && this.multiple) {
          this.searchFormData.tagCodes = val.split(",");
        } else {
          this.searchFormData.tagCodes = this.defaultTagCodes;
        }
        this.searchFormData.parentId = "0";
        this.search();
      }
    },
    tagCodes(val) {
      this.searchFormData.tagCodes = val;
      this.searchFormData.parentId = "0";
      this.search();
    }
  },
  methods: {
    /**
     * 重新搜索
     * */
    search() {
      this.searchFormData.parentId = "0";
      this.loadNode();
      this.$emit("node-click", this.searchFormData);
    },
    /**
     * 加载子节点
     */
    loadNode(node, resolve) {
      if (node) {
        this.searchFormData.parentId = node.data.id || "0";
      } else {
        this.searchFormData.parentId = "0";
      }
      let tagCodes = this.searchFormData.tagCodes.length
        ? this.searchFormData.tagCodes
        : [];
      let params = {
        parentId: this.searchFormData.parentId
      };
      if (this.positionId) {
        params.positionId = this.positionId;
      }
      if (this.isRole) {
        params.tagCode = tagCodes;
        this.$api.treeData(params).then(res => {
          if (this.searchFormData.parentId == "0") {
            this.$emit("getNodeValue", res.body.length > 0 ? res.body[0] : {});
          }
          if (resolve) {
            resolve(res.body);
            this.defaultExpandedKeys = ["1088640745113845762"];
          } else {
            this.treeData = res.body;
            if (this.treeData.length) {
              this.defaultExpandedKeys = [this.treeData[0].id];
            }
          }
        });
      } else if (this.old) {
        params.tagCodes = tagCodes;
        if (this.enable) {
          params.enable = 1;
        }
        this.$api.getOrganization(params).then(res => {
          if (this.searchFormData.parentId == "0") {
            this.$emit("getNodeValue", res.body.length > 0 ? res.body[0] : {});
          }
          if (resolve) {
            resolve(res.body);
            this.defaultExpandedKeys = ["1088640745113845762"];
          } else {
            this.treeData = res.body;
            if (this.treeData.length) {
              this.defaultExpandedKeys = [this.treeData[0].id];
            }
          }
        });
      } else {
        if (typeof tagCodes === "string") {
          params.tagCode = tagCodes;
        } else {
          params.tagCode = tagCodes[0];
        }
        this.$api.getOrganizationNew(params).then(res => {
          if (this.searchFormData.parentId == "0") {
            this.$emit("getNodeValue", res.body.length > 0 ? res.body[0] : {});
          }
          if (resolve) {
            resolve(res.body);
            this.defaultExpandedKeys = ["1088640745113845762"];
          } else {
            this.treeData = res.body;
            if (this.treeData.length) {
              this.defaultExpandedKeys = [this.treeData[0].id];
            }
          }
        });
      }
    },
    /**
     * 点击节点回调
     */
    handleNodeClick(data, node, nodeDom, isDbclick) {
      console.log("tree~~~~~~~~~", data);
      if (data.isSelected) {
        return;
      }
      this.$emit("node-click", data);
    },
    cancelSelect() {
      this.$refs.tree.setCurrentKey(null);
    },
    getCheckedKeys() {
      return this.$refs.tree.getCheckedKeys();
    },
    /**
     * 节点被点击回调
     */
    checkItem(data, node) {
      console.log(data);
      console.log(node);
    }
  }
};
</script>
<style lang="scss" scoped>
.components-organization-tree {
  /*    padding-left: 6px;
    padding-right: 6px;*/
  min-height: 100px;
  height: 100%;
  min-width: 200px;
  padding-top: 50px;
  position: relative;

  &.hideSearch {
    padding-top: 0px;
  }
}

.search-wrapper {
  position: absolute;
  top: 8px;
  left: 0;
  width: 100%;
  padding-left: 6px;
  padding-right: 6px;
}

.tree-wrapper {
  height: 100%;
}

.search-select {
  width: 100%;
}

.isSelected {
  color: #ccc;
}
</style>